import { Tooltip } from "antd";
import { useState } from "react";
import GeneralButton from "../../components/button/GeneralButton";
import FormInput from "../../components/formInput/FormInput";
import AddSubCategory from "../../components/modals/AddSubCategory";
import MergingSubCategories from "../../components/modals/MergingSubCategories";
import UploadCategoriesExcelModal from "../../components/modals/UploadCategoriesExcelModal";
import SubCategoryTable from "../../components/table/SubCategoryTable";
import useSubCategoryHook from "./customHooks/useSubCategoryHook";

import { FiGrid, FiSearch } from "react-icons/fi";

const SubCategories = () => {
    const {
        allSubCategories,
        handleNewCategoryModal,
        modal,
        selectedSubCategory,
        setSelectedSubCategory,
        onSubmit,
        handleDelete,
        onClose,
        setSearchValue,
        searchValue,
        setCanSearch,
    } = useSubCategoryHook();

    const [mergeModalOpen, setMergeModalOpen] = useState(false);
    const toggleMergeModal = () => setMergeModalOpen(!mergeModalOpen);

    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const toggleUploadModal = () => setUploadModalOpen(!uploadModalOpen);

    return (
        <div className="settings-container">
            {modal && (
                <AddSubCategory
                    modal={modal}
                    onClose={onClose}
                    toggle={handleNewCategoryModal}
                    type={selectedSubCategory ? "edit" : "add"}
                    onSubmit={onSubmit}
                    selectedSubCategory={selectedSubCategory}
                    setSelectedSubCategory={setSelectedSubCategory}
                />
            )}

            <MergingSubCategories
                modal={mergeModalOpen}
                toggle={toggleMergeModal}
            />

            <UploadCategoriesExcelModal
                isOpen={uploadModalOpen}
                toggle={toggleUploadModal}
                allCategories={allSubCategories}
                type="subcategory"
            />

            <div className="px-4">
                <div className="d-flex justify-content-between align-items-center mb-4 search-input-wrapper">
                    <div className="d-flex align-items-center gap-3 flex-1">
                        <div className="bg-primary-soft p-3 rounded-circle shadow-sm">
                            <FiGrid size={24} className="text-primary" />
                        </div>
                        <div>
                            <h4 className="fw-bold text-dark mb-0">Sub-Categories</h4>
                            <p className="text-muted small mb-0 mt-1">Management</p>
                        </div>
                    </div>

                    <div className="flex-1 d-flex justify-content-center">
                        <div style={{ width: "400px" }}>
                            <FormInput
                                type="text"
                                placeholder="Find a sub-category..."
                                size="large"
                                className="border-0 shadow-none"
                                icon={<FiSearch size={20} className="text-muted" />}
                                value={searchValue}
                                handleChange={(e) => {
                                    setCanSearch(true);
                                    setSearchValue(e.target.value);
                                }}
                            />
                        </div>
                    </div>

                    <div className="d-flex gap-3 flex-1 justify-content-end">
                        <Tooltip title="Update sub-categories in bulk using an Excel file">
                            <span>
                                <GeneralButton
                                    title={"Upload Excel"}
                                    className={"btn-action bg-white text-success border shadow-sm px-3"}
                                    handleClick={toggleUploadModal}
                                />
                            </span>
                        </Tooltip>
                        <Tooltip title="Merge multiple sub-categories into a single sub-category">
                            <span>
                                <GeneralButton
                                    title={"Merge Sub-Categories"}
                                    className={"btn-action bg-white text-dark border shadow-sm px-3"}
                                    handleClick={toggleMergeModal}
                                />
                            </span>
                        </Tooltip>
                        <Tooltip title="Create a new sub-category manually">
                            <span>
                                <GeneralButton
                                    title={"Add New Sub Category"}
                                    className={"create-user-btn text-white shadow-sm px-4"}
                                    handleClick={handleNewCategoryModal}
                                />
                            </span>
                        </Tooltip>
                    </div>
                </div>

                <div className="settings-card">
                    <SubCategoryTable
                        modal={modal}
                        data={allSubCategories}
                        toggle={handleNewCategoryModal}
                        setSelectedSubCategory={setSelectedSubCategory}
                        handleDelete={handleDelete}
                        onClearSearch={searchValue ? () => {
                            setSearchValue("");
                            setCanSearch(true);
                        } : undefined}
                    />
                </div>
            </div>
        </div>
    );
};

export default SubCategories;


